export const DYNAMIC_BACKGROUND_SELECTOR_OPTIONS = [
  { value: 'image', label: __('Image') },
  { value: 'video', label: __('Video') },
];

export const VIDEO_ARRANGEMENT_OPTIONS = [
  { value: 'fit', label: __('Fit') },
  { value: 'fill', label: __('Fill') },
];
